import React from 'react';
import { Empty } from 'antd';
import EmptyImage from '../../assets/image/empty.svg';
import ErrorImage from '../../assets/image/error.png';
import SafeUtil from '../../common/util/SafeUtil';
import './TableEmpty.less';
import Pager from '../../common/model/base/Pager';
import Lang from '../../common/model/global/Lang';
interface IProps {
  pager: Pager<any>;
  onRefresh?: () => void;
}

interface IState {}

class TableEmpty extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  render() {
    let that = this;

    let pager = this.props.pager;

    let emptyContent = (
      <div className="empty-content">
        <Empty image={EmptyImage} description={Lang.t('noData')}>
   
          <span
            className="link"
            onClick={(event) => {
              SafeUtil.safeCallback(that.props.onRefresh)();
            }}
          >
            {Lang.t('tyrAgain')}
          </span>
        </Empty>
      </div>
    );
    let errorContent = (
      <div className="error-content">
        <Empty image={ErrorImage} description={pager.errorMessage}>
          <span
            className="link"
            onClick={(event) => {
              SafeUtil.safeCallback(that.props.onRefresh)();
            }}
          >
           {Lang.t('tyrAgain')}
          </span>
        </Empty>
      </div>
    );

    return (
      <div className="widget-table-empty">
        {pager.errorMessage
          ? errorContent
          : pager.data.length
          ? ''
          : emptyContent}
      </div>
    );
  }
}

export default TableEmpty;
